// src/utils/http.js (or wherever your helper lives)
const API_BASE = import.meta.env.VITE_API_BASE || '/api';

// If you use cookies/sessions, change to 'include'
const CREDENTIALS = 'same-origin';

export function apiUrl(path = '') {
  const base = String(API_BASE).replace(/\/+$/, '');     // trim trailing slash
  const p = `/${String(path || '').replace(/^\/+/, '')}`; // ensure single leading slash
  return `${base}${p}`;
}

export async function apiPost(path, body, headers = {}) {
  const res = await fetch(apiUrl(path), {
    method: 'POST',
    credentials: CREDENTIALS,
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(body ?? {})
  });
  return handleResponse(res);
}

export async function apiGet(path, headers = {}) {
  const res = await fetch(apiUrl(path), {
    credentials: CREDENTIALS,
    headers
  });
  return handleResponse(res);
}

async function handleResponse(res) {
  const ct = res.headers.get('content-type') || '';
  const text = await res.text();

  if (!res.ok) {
    let message = 'Request failed';
    try {
      if (ct.includes('application/json') && text) {
        const err = JSON.parse(text);
        message = err?.detail || err?.message || JSON.stringify(err);
      } else if (text) {
        message = text;
      }
    } catch {}
    throw new Error(message);
  }

  if (text && ct.includes('application/json')) {
    return JSON.parse(text);
  }
  return text || null;
}
